// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@conklin/XDL/Utilities";
import { bannerStyles } from "@insite/content-library/Widgets/Category/CategoryDetailBanner";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

bannerStyles.container = {
    css: css`
        padding-bottom: 0;
        ${TypographyStyle} {
            margin-bottom: 0;
        }
        div {
            line-height: 26px;
        }
        ${({ horizontalRule }: any) => {
            if (horizontalRule) {
                return css`
                    padding-bottom: 32px;
                    margin-bottom: 32px;
                    border-bottom: 1px solid ${color("common.border")};
                `;
            }
        }}
    `,
};
